import { BATSVersion } from "../../../../models/pageConfiguration/BATSVersion";
import { SideNavItem } from "../../../../types/sideNavigation.type";
import { BATS_V4_SIDE_NAV_CONFIG } from "./Batsv4SideNavConfig";

export const SIDE_NAV_CONFIG: Record<BATSVersion, SideNavItem[]> = {
  [BATSVersion.BATSv4]: BATS_V4_SIDE_NAV_CONFIG,
};
